module.exports = __webpack_public_path__ + "img/5fcc67a.webp";